import LocalINTL from './LocalINTL';
import SimpleSuggest from './SimpleSuggest';

export {
  LocalINTL,
  SimpleSuggest
}